
export enum FormQuestionTypes {
    Text = 0,
    Numeric = 1,
    NumericScale = 2,
    AtlEval = 3,
    TlEval = 4,
    SingleOptionSelect = 5,
    MultiOptionSelect = 6
  }

  export const NumericQuestionTypes = [FormQuestionTypes.Numeric, FormQuestionTypes.NumericScale, FormQuestionTypes.AtlEval, FormQuestionTypes.TlEval] 

  export const TextQuestionTypes = [FormQuestionTypes.Text]
  
  export const Locales = ["en", "es"]
export interface PpmFormTranslation {
    id: number,
    formId: number,
    locale: string,
    name: string,
    instructions: string
}
  export interface PpmForm {
    id: number,
    uuid: string,
    name: string,
    instructions: string,
    active: number,
    translations: PpmFormTranslation[]
}

export interface PpmFormWithQuestions extends PpmForm {
    questions: FormQuestion[]
}

export interface FormOptionTranslation {
    id: number,
    formOptionId: number,
    locale: string,
    text: string
}

  export interface FormOption {
    id: number,
    text: string,
    formQuestionId: number,
    value?: number,
    active: number,
    order: number,
    allowTextResponse: number,
    translations?: FormOptionTranslation[]
  }

  export interface FormQuestionTranslation {
    id: number,
    formQuestionId: number,
    locale: string,
    text: string,
    scaleHigh: string,
    scaleLow: string
  }
export interface FormQuestion{ 
    id: number,
    formId: number,
    type: FormQuestionTypes,
    required: number,
    active: number,
    text: string,
    reportText: string,
    scaleLow: string,
    scaleHigh: string,
    options: FormOption[],
    order: number,
    translations: FormQuestionTranslation[],

}


export interface FormResponseTrip {
    id: number,
    formResponseId: number,
    tripId: number
}

export interface FormResponseOptionSelection {
    id: number,
    formQuestionResponseId: number,
    formOptionId: number,
    text?: string
}
export interface FormQuestionResponse {
    id: number,
    formQuestionId: number,
    formResponseId: number,
    text?: string | null,
    value?: number | null,
    staffId?: number | null,
    optionSelections?: FormResponseOptionSelection[]
}

export interface FormResponse {
    id: number,
    formId: number,
    staffId?: number,
    contactId?: string,
    newuserId?: string,
    isSubmitted: number
    responseTrips?: FormResponseTrip[],
    questionResponses?: FormQuestionResponse[],
    dateCreated: Date,
    dateSubmitted?: Date

}



export interface FormResponseStaffEval {
    staffId: number
    value: number
}

export interface FormResponseMultiSelectValue {
    id: number,
    text?: string
}

export interface FormResponseReportQuestion {
    type: FormQuestionTypes
    order: number
    value?: number
    text?: string
    staffEvals?: FormResponseStaffEval[],
    multiSelectValues?: FormResponseMultiSelectValue[]
}
export interface FormResponseReportLine extends FormResponse {
    responder: string,
    responderType: string,
    locationId?: string,
    locationName?: string,
    tripLeader?: string,
    trips: { id: number, custId: number, groupname: string, tripDate: Date }[],
    tripDate: Date,
    [prop: number]: FormResponseReportQuestion
}

export interface FormResponseTrip {
    id: number,
    custId: number
}

export interface FormResponseValueAggregate {
    sum: number,
    count: number,
    average: number
}
export interface StaffEvalReportLine {
    staffId: number,
    staffName: string,
    [prop: number]: FormResponseValueAggregate
}